import { getCurrencyFormat, getCompactCurrencyFormat } from './locale';

export const localizeCurrency = (amount: number, currency?: string, locale?: string) =>
  getCurrencyFormat(currency, locale).format(amount);

export const localizeCompactCurrency = (amount: number, currency?: string, locale?: string) =>
  getCompactCurrencyFormat(currency, locale).format(amount);
